module.exports = {"540529100":"隆子镇","540529101":"日当镇","540529200":"列麦乡","540529201":"热荣乡","540529202":"三安曲林乡","540529203":"准巴乡","540529204":"雪萨乡","540529205":"扎日乡","540529206":"玉麦乡","540529207":"加玉乡","540529208":"斗玉珞巴民族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540529.json
// module id = 2868
// module chunks = 0